import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PregledDolznika.css";

export default function PregledDolznika() {
    const navigate = useNavigate();
    const [clickedLinks, setClickedLinks] = useState({});

    const resources = [
        {
            id: "pregled1",
            title: "AJPES – eINSOLV",
            desc: "Vpogled v Vpisnik zadev v postopkih zaradi insolventnosti VS RS.",
            href: "https://www.ajpes.si/eInsolv/",
        },
        {
            id: "pregled2",
            title: "CRP Slovenija",
            desc: "Portal Centralnega registra prebivalstva Slovenije.",
            href: "https://ecrp.gov.si/",
        },
        {
            id: "pregled3",
            title: "AJPES (RZPP)",
            desc: "Register neposestnih zastavnih pravic in zarubljenih premičnin (RZPP).",
            href: "https://www.ajpes.si/registri/zastava_premicnin/splosno",
        },
        {
            id: "pregled4",
            title: "Register motornih vozil",
            desc: "Portal za Register motornih vozil.",
            href: "https://e-uprava.gov.si/si/javne-evidence/motorna-vozila.html?lang=si",
        },
    ];

    const handleLinkClick = (id) => {
        setClickedLinks((prev) => ({
            ...prev,
            [id]: true,
        }));
    };

    return (
        <div className="pregdolz-root">
            <main className="pregdolz-page">
                <section className="pregdolz">
                    <div className="pregdolz-header">
                        <div className="pregdolz-header-meta">
                            <h1 className="pregdolz-header-title">
                                Pregled dolžnika
                            </h1>

                            <p className="pregdolz-header-subtitle">
                                Hitra zbirka povezav za preverjanje osnovnih podatkov o
                                dolžniku pred ali med izvršbo.
                            </p>
                        </div>

                        <button
                            type="button"
                            className="btn-nazaj"
                            onClick={() => navigate("/profil", { replace: false })}
                            aria-label="Nazaj na profil"
                            title="Nazaj"
                        >
                            <span className="btn-nazaj__icon" aria-hidden="true">
                                ←
                            </span>
                        </button>
                    </div>

                    <div className="pregdolz-grid">
                        {resources.map((res) => (
                            <article key={res.id} className="pregdolz-card">
                                <h3 className="pregdolz-cardTitle">{res.title}</h3>

                                <p className="pregdolz-cardText">{res.desc}</p>

                                <a
                                    className={
                                        "pregdolz-link" +
                                        (clickedLinks[res.id]
                                            ? " pregdolz-link--clicked"
                                            : "")
                                    }
                                    href={res.href}
                                    target="_blank"
                                    rel="noreferrer"
                                    onClick={() => handleLinkClick(res.id)}
                                >
                                    {clickedLinks[res.id]
                                        ? "Pregledano"
                                        : "Odpri povezavo"}
                                </a>
                            </article>
                        ))}
                    </div>
                </section>
            </main>
        </div>
    );
}